<template>
  <InfiniteScroll
    :is-done="isDone"
    :is-loading="isLoading"
    @reached="fetchCertificates"
  >
    <UserProfileCertificatesList
      v-if="certificates.length"
      :type="type"
      :certificates="certificates"
    />

    <NoRecordsInlineText v-else-if="!isLoading">
      Sem certificações por enquanto
    </NoRecordsInlineText>

    <slot
      name="append"
      v-bind:certificates="certificates"
      v-bind:isLoading="isLoading"
    />
  </InfiniteScroll>
</template>

<script>
import InfiniteScroll from '../../layout/InfiniteScroll.vue'
import { getCertificatesByUser } from '@/api/certificate.api'
import UserProfileCertificatesList from './UserProfileCertificatesList.vue'
import NoRecordsInlineText from '../../text/NoRecordsInlineText.vue'

export default {
  props: {
    user: { type: Object, required: true },
    type: { type: String, required: true },
    perPage: { type: Number, required: true },
    once: { type: Boolean, default: false }
  },

  components: {
    InfiniteScroll,
    UserProfileCertificatesList,
    NoRecordsInlineText,
  },

  data: () => ({
    isLoading: false,
    certificates: [],
    page: 1,
    isDone: false,
  }),

  methods: {
    async fetchCertificates () {
      this.isLoading = true
      
      const response = await getCertificatesByUser(this.user.id, {
        page: this.page++,
        perPage: this.perPage
      })

      response.data.data.forEach(certificate => this.certificates.push(certificate))

      this.isDone = this.once || response.data.links.next === null

      this.isLoading = false
    },
  }
}
</script>